module.exports = __webpack_public_path__ + "img/IT.520bdd3b.svg";